import { FREQUENTLY_USED_EMAILS } from '../../constants';
import { IFrequentlyBoughtProduct } from '@monofront/types';

export class UserService {
  private customerCRUD;
  private authCRUD;
  private legoUrl;

  constructor(customerCrud, authCrud, legoUrl) {
    this.customerCRUD = customerCrud;
    this.authCRUD = authCrud;
    this.legoUrl = legoUrl;
  }

  public createUser(email: string, password: string) {
    return this.authCRUD.createUser(email, password);
  }

  public updateFirstName(firstName: string, uid?: string) {
    return this.customerCRUD.update(uid, { firstName });
  }

  public updateLastName(lastName: string, uid?: string) {
    return this.customerCRUD.update(uid, { lastName });
  }

  public updateEmail(email: string) {
    return this.authCRUD.update({ newEmail: email });
  }

  public updateFbPixelData(
    userAgent: string,
    fbp?: string,
    fbc?: string,
    uid?: string,
  ) {
    return this.customerCRUD.update(uid, {
      facebookTrackingData: {
        lastUserAgent: userAgent,
        lastFbp: fbp || null,
        lastFbc: fbc || null,
      },
    });
  }

  updateSubscribingFrom(from: 'web' | 'mobile', uid: string): Promise<void> {
    return this.customerCRUD.update(uid, {
      subscribingFrom: from,
    });
  }

  public updatePassword(
    email: string,
    currentPassword: string,
    newPassword: string,
  ) {
    return this.authCRUD.update({ email, currentPassword, newPassword });
  }

  public updateShoppingCartId(shoppingCartId: string, uid: string) {
    return this.customerCRUD.update(uid, { shoppingCartId });
  }

  public sendPasswordResetEmail(email: string) {
    return this.authCRUD.sendPasswordResetEmail(email);
  }

  public getUserFrequentlyBoughtProducts = async (
    uid: string,
    limit?: number,
  ): Promise<IFrequentlyBoughtProduct[]> => {
    const userItemsOrdered = (await this.customerCRUD.read(uid, {
      collection: 'itemsOrdered',
      limit,
      orderBy: [
        { direction: 'desc', value: 'timesOrdered' },
        { direction: 'desc', value: 'quantityOrdered' },
        { direction: 'desc', value: 'lastOrderedAt' },
      ],
    })) as IFrequentlyBoughtProduct[];

    return userItemsOrdered;
  };

  public validateEmail = async (email: string): Promise<boolean> => {
    if (!FREQUENTLY_USED_EMAILS.includes(email.split('@')[1])) {
      const response = await fetch(this.legoUrl + '/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
          query: `mutation ValidateEmail($email: String!) {
            validateUserEmail(email: $email)
          }`,
          variables: {
            email,
          },
        }),
      });

      const {
        data: { validateUserEmail },
      } = await response.json();

      return validateUserEmail as boolean;
    }

    return Promise.resolve(true);
  };

  public updateHouseholdSize = async (
    householdSize: number,
    uid: string,
  ): Promise<void> => {
    return this.customerCRUD.update(uid, { householdSize });
  };
}
